// @flow
import React from 'react'
import I18n from 'i18n-react'
// core
import { getValidCalculatorsForProductName } from '../FilterFunctions'
// components
import QuoteTextFilter from './_filterComponents/QuoteTextFilter.jsx'
import RadioTextFilter from './_filterComponents/RadioTextFilter.jsx'
//types
import type { InsuranceCompaniesType } from '../Types/InsuranceCompanyTypes'
import type { FilterDomainType } from './_filterComponents/QuoteTextFilter'
import type { AsMutable, AsMutableArray } from '../Types/ImmutableTypes'
import type { QuoteFilterBlockType } from '../Types/FilterTypes'

import { config } from '../../Config/ConfigLoader'

type FilterProps = {
  cicEnabled: boolean,
  className: string,
  data: QuoteFilterBlockType & AsMutable,
  enabledCalculators: Array<string> & AsMutableArray,
  fieldNames: { [key: string]: string },
  filterBlocks: QuoteFilterBlockType,
  insuranceCompanies: InsuranceCompaniesType,
  onChange: (tab: string, name: string, value: string, multiSelect?: boolean) => void,
  onChangeEnabledCalculators: (Array<string>) => boolean,
  onChangePayment: (string) => void,
  productName: string,
  textMode?: boolean,
  userData: { [key: string]: any },
}

const QuoteFilter = (props: FilterProps) => {
  const getChecked = (data: QuoteFilterBlockType) =>
    Object.keys(data).reduce((checkAcc, tab) => {
      if (!checkAcc[tab]) {
        checkAcc[tab] = 0
      }
      checkAcc[tab] += Object.keys(data[tab]).reduce((sumAcc, itemKey) => {
        sumAcc += data[tab][itemKey].length
        return sumAcc
      }, 0)
      return checkAcc
    }, {})

  const handleOnChange = (tab: string, name: string, value: string, multiSelect?: boolean = false) => {
    /*const checkedSum = getChecked(props.data)
    const maxChecked = getChecked(props.filterBlocks)
    if (checkedSum[domain.tab] !== 1 && !checked || checked && checkedSum[domain.tab] < maxChecked[domain.tab] - 1) {*/
    props.onChange(tab, name, value, multiSelect)
    //}
  }

  const handleChangeEnabledCalculators = (domain: FilterDomainType, checked: boolean, calculators) => {
    let newValueForEnabledCalculators = props.enabledCalculators
    if (checked) {
      if (newValueForEnabledCalculators.asMutable) {
        newValueForEnabledCalculators = newValueForEnabledCalculators.asMutable()
      }
      calculators.map((calculator) => {
        newValueForEnabledCalculators.push(calculator)
      })
    } else {
      newValueForEnabledCalculators = newValueForEnabledCalculators.filter(
        (calculator) => !calculators.includes(calculator),
      )
    }
    if (newValueForEnabledCalculators.length === 0) {
      return false
    }
    props.onChangeEnabledCalculators(newValueForEnabledCalculators)
    return true
  }

  const handleOnChangePayment = (payment: string) => {
    props.onChangePayment(payment)
  }

  return (
    <div className="card-body px-0 px-sm-3">
      <div className="text-center">
        <h2>{I18n.translate('filter.name')}</h2>
        <hr className="border-0 border-sm-top border-active-object" />
      </div>
      <div className="form-group d-flex flex-row flex-wrap flex-sm-row align-items-top" key="filter-payment">
        <div className="col-10 col-sm-3 order-0 order-sm-0 text-sm-right pt-sm-2">
          <label className="mb-0 mr-4 text-nowrap font-weight-bold">{props.fieldNames.paymentPeriod}</label>
        </div>
        <div className="col-12 col-sm-8 order-3 order-sm-0 offset-sm-1 mt-2 mt-sm-0 pr-0">
          <div className="row w-100">
            {config
              .getConfig('quoteListContainer.filterConfig.blocks.tpl')
              .filter((block) => block.name === 'payment')[0]
              .options.map((option) => (
                <RadioTextFilter
                  activeValue={props.userData.paymentPeriod}
                  customClassNames="col-6 col-md-3 px-0 mr-0 py-2"
                  domain={{
                    name: option.name,
                    value: option.value,
                    key: option.key,
                  }}
                  key={`filter-payment-${option.key}`}
                  onChange={(domain, checked) => {
                    handleOnChangePayment(checked)
                  }}
                  parentName="paymentPeriod"
                  textMode={props.textMode || false}
                />
              ))}
          </div>
        </div>
      </div>
      {Object.keys(props.filterBlocks).map(tab =>
        Object.keys(props.filterBlocks[tab]).map(filter => {
          return ((tab !== 'cic' || props.cicEnabled) && !filter.includes('range') && [
            <div className='form-group d-flex flex-row flex-wrap flex-sm-row align-items-top'
                 key={`filter-${tab}-${filter}`}>
              <div className='col-10 col-sm-3 order-0 order-sm-0 text-sm-right pt-sm-2'>
                <label className='mb-0 mr-4 text-nowrap font-weight-bold' htmlFor={filter}>
                  {I18n.translate(`filter.${tab}.${filter}`)}
                </label>
              </div>
              <div className='col-12 col-sm-8 order-3 order-sm-0 offset-sm-1 mt-2 mt-sm-0 pr-0'>
                <div className='row w-100'>
                  {props.filterBlocks[tab][filter].map(param => {
                    const activeValue = props.data.getIn([tab, filter], '')
                    return (
                      <RadioTextFilter
                        activeValue={Array.isArray(activeValue) ? activeValue[0] : ''}
                        customClassNames='col-6 col-md-3 px-0 mr-0 py-2'
                        domain={{
                          name: filter,
                          value: param,
                          key: `${tab}.${param}`
                        }}
                        key={`filter-${tab}-${filter}-${param}`}
                        onChange={(name, value) => {
                          handleOnChange(tab, name, value)
                        }}
                        parentName='paymentPeriod'
                        textMode={props.textMode || false}
                      />
                    )
                  })}
                </div>
              </div>
            </div>
          ])
        })
      )}
      {Object.keys(props.insuranceCompanies).length > 0 && [
        <div
          className="form-group d-flex flex-row flex-wrap flex-sm-row align-items-top"
          key="filter-insuranceCompanies"
        >
          <div className="col-10 col-sm-3 order-0 order-sm-0 text-sm-right pt-sm-2">
            <label className="mb-0 mr-4 text-nowrap font-weight-bold">
              {I18n.translate('general.insuranceCompanies')}
            </label>
          </div>
          <div className="col-12 col-sm-8 order-3 order-sm-0 offset-sm-1 mt-2 mt-sm-0">
            <div className="row">
              {Object.keys(props.insuranceCompanies).map((insuranceCompanyKey) => {
                const validCalculators = getValidCalculatorsForProductName(
                  { [insuranceCompanyKey]: props.insuranceCompanies[insuranceCompanyKey] },
                  props.productName,
                )

                if (validCalculators.length === 0) {
                  return null
                }

                const calculator = validCalculators[0]
                return (
                  <QuoteTextFilter
                    checked={props.enabledCalculators.includes(calculator)}
                    domain={{
                      name: insuranceCompanyKey,
                      tab: '',
                      value: calculator,
                      valueName: `${props.insuranceCompanies[insuranceCompanyKey].shortName}`,
                    }}
                    key={`filter-${insuranceCompanyKey}-${calculator}`}
                    onChange={(domain: FilterDomainType, checked: boolean) => {
                      handleChangeEnabledCalculators(domain, checked, validCalculators)
                    }}
                    textMode={props.textMode || false}
                  />
                )
              })}
            </div>
          </div>
        </div>,
      ]}
    </div>
  )
}

export default QuoteFilter
